import axios, { AxiosError } from 'axios'
import { httpClient, authRequest } from 'shared/lib'
import consoleMessage from 'shared/utils/helpers/consoleMessage'
import { AuthorizationResult, LoginPayload, SwapLoginPayload } from './types'

function isAxiosError<ResponseType>(error: unknown): error is AxiosError<ResponseType> {
   return axios.isAxiosError(error)
}

export function authorizeUser(payload: LoginPayload) {
   // eslint-disable-next-line no-extra-boolean-cast
   const headers = !!process.env.REACT_APP_TENANT
      ? {
           'X-Tenant': process.env.REACT_APP_TENANT,
           'X-Fingerprint': payload.fingerPrint,
        }
      : {
           'X-Fingerprint': payload.fingerPrint,
        }

   return httpClient
      .post<AuthorizationResult>(
         'user/login',
         { username: payload.email, password: payload.password, verificationCode: payload.smsCode },
         {
            headers,
         }
      )
      .then((res) => res.data)
      .catch((error: Error | AxiosError<ErrorType>) => {
         if (isAxiosError<ErrorType>(error)) {
            consoleMessage(
               'LOGIN',
               error.response?.data.errors[0].defaultMessage || 'PROBLEM WITH authorizeUser() SERVICE',
               'error'
            )
            return {
               accessToken: null,
               refreshToken: null,
               error: error.response?.data?.errors
                  ? error.response.data.errors[0]?.defaultMessage
                  : 'INVALID_CREDENTIALS',
            }
         }
         if (error instanceof Error) {
            consoleMessage('LOGIN', error.message || 'PROBLEM WITH authorizeUser() SERVICE', 'error')
            return {
               accessToken: null,
               refreshToken: null,
               error: error.message || 'INVALID_CREDENTIALS',
            }
         }
         consoleMessage('LOGIN', 'PROBLEM WITH authorizeUser() SERVICE which is unknown', 'error')
         return {
            accessToken: null,
            refreshToken: null,
            error: 'Unauthorized',
         }
      })
}

export async function revokeToken(params: URLSearchParams) {
   return authRequest.post('/token/revoke', params).catch((error: Error | AxiosError<ErrorType>) => {
      if (isAxiosError<ErrorType>(error)) {
         consoleMessage('LOGOUT', error.response?.data.errors[0].code || 'PROBLEM WITH revokeToken() SERVICE', 'error')
      }
      consoleMessage('LOGOUT', error.message || 'PROBLEM WITH revokeToken() SERVICE', 'error')
   })
}

export async function swapUser(payload: SwapLoginPayload) {
   return httpClient
      .post<AuthorizationResult>('session/swap', {
         ...payload,
      })
      .then((res) => res.data)
      .catch((error: Error | AxiosError<AuthorizationResult>) => {
         if (axios.isAxiosError(error)) {
            consoleMessage(
               'LOGIN',
               error.response?.data.errors[0].defaultMessage || 'PROBLEM WITH swapUser() SERVICE',
               'error'
            )
            return {
               accessToken: null,
               refreshToken: null,
            }
         }
         consoleMessage('LOGIN', error.message || 'PROBLEM WITH swapUser() SERVICE', 'error')
         return {
            accessToken: null,
            refreshToken: null,
         }
      })
}
